import axios from "axios";
export default {
    saveWorkSpace: (workSpace) => axios.post("/WorkSpaces/SaveWorkSpace", workSpace),
    getWorkSpace: (workSpaceId) => axios.post("/WorkSpaces/GetWorkSpace", { Id: workSpaceId })
};
